import {BaseModel} from '@/core/standard/BaseModel';
import {
  IKitchenTickets,
  IKitchenTicketSettingsModel,
  KitchenTicketSettingsProtocol,
} from '@/modules/settings/kitchen-ticket/IKitchenTicketSettingsModel';
import KitchenTicketSettingServices from '@/modules/settings/kitchen-ticket/KitchenTicketSettingServices';

const ticketSettings = {
  id: '',
  show_local_header: false,
  show_domicile_header: false,
  show_price_per_unit: false,
  show_total_price: false,
  show_command_guests: false,
  group_by_orders: false,
  show_person_name: '',
  header_font: {name: '', style: '', size: ''},
  details_font: {name: '', style: '', size: ''},
  small_details_font: {name: '', style: '', size: ''},
  print_by: '',
};

// tslint:disable-next-line:max-line-length
class KitchenTicketSettingsModel extends BaseModel<IKitchenTicketSettingsModel, KitchenTicketSettingsProtocol, typeof KitchenTicketSettingServices> {
  public modelName = 'Ticket';
  public request = 'JSON';

  constructor() {
    super(ticketSettings, KitchenTicketSettingServices);
  }

  public async create(data: FormData, toast: any, toastConfig: any) {
    const request = await this.service.request({method: 'PUT', query: data});
    if (request.complete) {
      return this.handleSuccess(request.data, request.message, toast);
    } else {
      this.handleError(request, toast);
      return false;
    }
  }

}

export default KitchenTicketSettingsModel as new() => IKitchenTickets;
